import $$ from 'cmn-utils'

const baseUrl = "/api/order/task/";
export default {
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    get: function get(params) {
        return $$.get(baseUrl + 'get', params)
    },

    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    submit: (params) => {
        return $$.post(baseUrl + 'submit', params)
    },
    totalState:(params)=>{
        return $$.get(baseUrl+'total-state',params)
    }
}